/**
 * React Query hook for bulk completing inspection reviews
 */
import { toast } from 'react-hot-toast';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { translate } from '@utils/i18n';
import InspectionsReviewService from '../services/InspectionsReviewService';
const namespace = 'features.ai_to_review_inspections.bulk_actions';
/**
 * Hook for bulk completing inspection reviews with cache invalidation
 * @returns Mutation object for bulk completing inspection reviews
 */
export default function useBulkCompleteReview() {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: (params) => InspectionsReviewService.bulkCompleteReview(params),
        onSuccess: (data) => {
            // Invalidate the main inspections review query to refetch the list
            void queryClient.invalidateQueries({ queryKey: ['ai-review-inspections'] });
            if (data.failed && data.failed.length > 0) {
                toast.error(translate('bulk_complete_partial_success', {
                    namespace,
                    completed: data.completed_count,
                    failed: data.failed.length
                }));
            }
            else {
                toast.success(translate('bulk_complete_success', {
                    namespace,
                    count: data.completed_count
                }));
            }
        },
        onError: (error) => {
            console.error('Error bulk completing reviews:', error);
            toast.error(translate('bulk_complete_error', { namespace }));
        }
    });
}
